export const hindiTranslations = {
  agentGrm: {
    ADD_DETAILS: "विवरण जोड़ें",
    CATEGORY: "वर्ग",
    COMMON_SUB_CATEGORY: "उपश्रेणी",
    COMMON_SUB_SUB_CATEGORY: "उप-उप-श्रेणी",
    GRIEVANCE_SUBJECT: "उप-उप-श्रेणी",
    grmApplication: "जीआरएम आवेदन",
    grmApplicationSubText: "वह श्रेणी चुनें जिसके अंतर्गत आपकी शिकायत आती है",
    selectCategoryType: "वर्ग चुनें",
    selectSubCategoryType: "उपश्रेणी, उप-उप-श्रेणी चुनें",
    categoryType: "वर्ग प्रकार",
    governmentSchemesRelated: "सरकारी योजनाएँ संबंधित सेवाएँ",
    privateSchemeRelated: "निजी योजनाएँ संबंधित सेवाएँ",
    SELECT_SUB_CATEGORY: "उपश्रेणी चुनें",
    SELECT_SUB_SUB_CATEGORY: "उप-उप-श्रेणी चुनें",
    SELECTED_FILES: "अपलोड की गई फ़ाइलें",
    SUB_CATEGORY: "उपश्रेणी",
    WRITE_COMMENTS: "अपनी टिप्पणियाँ लिखें",
    UPLOAD_FILES: "फाइलें अपलोड करें",
    GRM_CREATE_SUCCESS_MSG: "शिकायत सफलतापूर्वक उठाई गई है",
    GRM_TICKET_NUMBER: "टिकट संख्या",
    COMMON_RESEND_ANOTHER_OTP: "नहीं मिला??",
    COMMON_RESEND_ANOTHER_OTP_TAIL: "सेकंड में पुनः भेजें",
    GRM: "जीआरएम",
    GRM_APPLICATION: "जीआरएम एप्लीकेशन",
    CATEGORY_SELECTION_ERROR: "कृपया वर्ग चुनें",
    SUB_CATEGORY_SELECTION_ERROR: "कृपया उपश्रेणी चुनें",
    SUB_SUB_CATEGORY_SELECTION_ERROR: "कृपया उप-उप-श्रेणी चुनें",
    SUBMIT: "ज़मा करें",
  },
  agentTrack: {
    GRM_TICKET_NUMBER: "टिकट संख्या",
    SCHEME_TICKET_NUMBER: "आवेदन संख्या",
    TRACK_SERVICE: "ट्रैक सेवा",
    TRACK_SERVICE_SUBTEXT:
      "वह सेवा चुनें जिसके अंतर्गत आप ट्रैक करना चाहते हैं",
    GRM_TICKET_NUMBER_ENTER:
      "कृपया टिकट नंबर दर्ज करें जिसे आप ट्रैक करना चाहते हैं",
    SCHEME_TICKET_NUMBER_ENTER:
      "कृपया वह एप्लिकेशन नंबर दर्ज करें जिसे आप ट्रैक करना चाहते हैं",
    SELECT_TRACK_OPTION: "कृपया वह विकल्प चुनें जिसे आप ट्रैक करना चाहते हैं",
    TRACK: "ट्रैक",
    TRACK_GRM: "जीआरएम",
    TRACK_SCHEME: "योजना",
    TICKET_VALIDATION_ERROR: "कृपया वैध टिकट संख्या दर्ज करें",
    SERVICE_VALIDATION_ERROR: "कृपया सेवा चुनें",
  },
  schemeTrack: {
    SCHEMES_TRACK: "योजना आवेदन विवरण",
  },
  appBar: {
    home: "होम स्क्रीन",
    aboutUs: "हमारे बारे में",
    schemes: "कार्यक्रम एवं योजनाएँ",
    majorCrops: "प्रमुख फसलें",
    logout: "लॉग आउट",
    welcome: "स्वागत हे!",
  },
  home: {
    Dashboard: "डैशबोर्ड",
    Schemes: "योजनाओं",
    homePageCards: {
      newFarmers: "नये किसानों का पंजीयन हुआ",
      applications: "योजनाओं के लिए आवेदन जमा किये गये",
    },
    Advisory: "सलाहकार",
    Marketplace: "बाजार",
    Grievance: "शिकायत",
    Insurance: "बीमा",
    Credit: "श्रेय",
    ENTER_OTP: "ओटीपी दर्ज करें"
  },
  schemes: {
    allschemes: "योजनाएँ",
    myschemes: "मेरी योजनाएँ",
    searchSchemes: "योजनाएँ खोजें",
    showingResultsPage: "प्रति पृष्ठ पर अधिकतम {{results}} परिणाम दिखा रहे हैं",
    more: "अधिक",
    apply: "आवेदन करें",
    save: "सहेजें & आगे",
    back: "वापस",
    close: "बंद करे",
    preview: "पूर्वावलोकन",
    registrationForm: "पंजीकरण फार्म",
    agricultureSchemes: "कृषि योजनाएँ",
    fisheriesSchemes: "मत्स्य पालन योजनाएँ",
    horticultureSchemes: "बागवानी योजनाएँ",
    small: "छोटा",
    medium: "मध्यम",
    large: "बड़ा",
    "<2acres": "<2 एकड़",
    "2-5acres": "2-5 एकड़",
    ">5acres": ">5 एकड़",
    schemeTypes: "योजनाओं",
    farmerTypes: "किसान वर्ग",
    landSize: "भूमि सीमा",
    appliedBeeScreenError:
      "मधु निष्काशन यन्त्र तथा फूड ग्रेड कंटेनर में से किसी एक अवयव का ही लाभ लिया जा सकता है। कृपया किसी एक के लिए हाँ का चयन करें",
    schemesForFarmers: "किसानों के लिए योजनाएँ",
    schemeDetails: "योजना का विवरण",
    schemeKnowMore: "और जानें",
    filterBy: "फ़िल्टर करें",
    sortBy: "क्रमबद्ध करें",
    stateScheme: "राज्य योजना",
    centralSponsored: "केंद्रीय प्रायोजित",
    centralScheme: "केंद्रीय योजना",
    applicationWindow: "आवेदन विंडो",
    schemeAbout: "योजना के बारे में जानकारी",
    schemeApplyNow: "आवेदन करें",
    schemeVerifyFarmer: "किसान विवरण सत्यापित करें",
    schemeVerifyFarmerSubtext:
      "कृपया आगे बढ़ने से पहले किसान डीबीटी विवरण सत्यापित करें",
    farmerDBTId: "किसान की डीबीटी आईडी दर्ज करें",
    otpSentMessage:
      "एक वन-टाइम पासवर्ड किसान के पंजीकृत मोबाइल नंबर पर भेजा गया है, जो {{mobile}} पर समाप्त होता है",
    memberOtpSentMessage:
      "एक वन-टाइम पासवर्ड सदस्य के पंजीकृत मोबाइल नंबर पर भेजा गया है",
    getOTP: "ओटीपी प्राप्त करें",
    sendingOTP: "ओटीपी भेजा जा रहा है..",
    otpVerifieng: "ओटीपी सत्यापन...",
    otpSuccess: "ओटीपी भेजा गया!",
    otpFailed: "ओटीपी विफल हुआ!!",
    enterOTP: "वन-टाइम पासवर्ड दर्ज करें",
    verify: "सत्यापित करें",
    resendOtp: "ओटीपी पुनः भेजें",
    resendOtpIn: "{{seconds}} सेकंड में ओटीपी पुनः भेजें",
    confirmCancel: "किसान लॉग आउट हो जायेगा!! क्या आप यह चाहते हैं??",
    confirmNavigation:
      "यदि लॉग इन है तो किसान लॉग आउट हो जाएगा। क्या आप सुनिश्चित हैं??",
    applicationTypeRequired: "कृपया आवेदक का प्रकार चुनें।",
    createSchemeApplication: "स्कीम फॉर्म भरें",
    enterDetailsForFarmerApplication:
      "किसान आवेदन बनाने के लिए निम्नलिखित जानकारी भरें।",
    applicationForm: "आवेदक का प्रकार चुनें",
    open: "खुली",
    closed: "बंद",
    new: "नई",
    latest: "नवीनतम",
    default: "डिफ़ॉल्ट",
    gramUnit: "ग्राम",
    kilogramUnit: "किलो ग्राम",
    sortAlphAsc: "अ -> ज्ञ",
    sortAlphDesc: "ज्ञ -> अ",
    noSchemes: "कोई योजना उपलब्ध नहीं है",
    fetchingLocationData: "स्थान संबंधी जानकारी प्राप्त की जा रही है...",
    locationDataLoaded: "स्थान संबंधी जानकारी सफलतापूर्वक प्राप्त हो गई है",
    addRecord: "रिकॉर्ड जोड़ें",
    submit: "ज़मा करें",
    confirmLandDetails:
      "{{component}} के डेटा साफ़ कर दिए जाएंगे। क्या आप सुनिश्चित हैं?",
    farmerConsent:
      "मैं इस द्वारा घोषणा करता हूँ कि मैं किसान की ओर से यह आवेदन भर रहा हूँ और ऊपर दी गई सभी जानकारी सही है। यदि इनमें से कोई भी जानकारी गलत पाई जाती है, तो मैं इस आवेदन के अस्वीकृति के लिए जिम्मेदार रहूँगा और सब्सिडी राशि किसान से वसूली जा सकती है, जिसके लिए मैं दंडात्मक कार्यवाही के लिए उत्तरदायी रहूँगा।",
    preview: "पूर्वावलोकन",
    cancel: "रद्द करें",
    previous: "पीछे जाएँ",
    next: "आगे बढ़ें",
    yes: "हाँ",
    no: "नहीं",
    totalArea: "कुल रकवा",
    totalAppliedArea: "कुल आवेदित रकवा",
    totalAreaAcre: "कुल रकवा - {{area}} एकड़",
    totalAppliedAreaAcre: "कुल आवेदित रकवा - {{area}} एकड़",
    seedQuantity: "बीज की मात्रा - {{quantity}} {{unit}}",
    remove: "हटाएं",
    submitApplication: "आवेदन जमा करें",
    documentPreview: "अपलोड की गई फाइलें",
    homePage: "होमपेज",
    SCHEME_CREATE_MESSAGE: "आवेदन सफलतापूर्वक जमा कर दिया गया है",
    schemeCreated: "आवेदन की तिथि : {{date}}",
    schemeNumber: "आवेदन संख्या: {{number}}",
    applicationStatus: "स्थिति: {{status}}",
    fileSizeInfo: "अधिकतम फ़ाइल आकार: 2MB",
    alreadyAppliedSeed: "किसान के द्वारा आवेदन किया जा चुका है।",
    documentContentEmpty:
      "इस अनुभाग के लिए वर्तमान में कोई सामग्री उपलब्ध नहीं है। आप अपडेट के लिए बाद में पुनः जांच सकते हैं।",
    selectSeasonSeed: "फसल सत्र चुनें",
    paginationTitle: "प्रति पृष्ठ अधिकतम {{count}} परिणाम दिखाए जा रहे हैं",
    type: "प्रकार",
    name: "नाम",
    individualBorvelWork: "Borewell का कार्य ",
    schemeSubName: "योजना",
    cropCode: "योजना कोड",
    bananaCols: {
      S_No: "क्र०सं०",
      strain: "प्रभेद",
      appliedAreaFor: "आवेदित रकवा(एकड़ में)*",
    },
    NOFORM: "आवेदन फॉर्म इस समय उपलब्ध नहीं है। कृपया बाद में पुनः प्रयास करें।",
    INVALIDURL: "आवेदन पृष्ठ खोलने में असमर्थ। कृपया बाद में पुनः प्रयास करें।",
  },

  schemeErrors: {
    fieldIsRequired: "यह फ़ील्ड अनिवार्य है",
    invalidEmail: "अमान्य ईमेल पता",
    invalidIntegerFormat: "अमान्य पूर्णांक संख्या प्रारूप",
    invalidDecimalFormat: "अमान्य दशमलव संख्या प्रारूप",
    minLengthError: "न्यूनतम आवश्यक लंबाई {{length}} है",
    maxLengthError: "केवल अधिकतम {{length}} वर्ण की अनुमति है",
    minValueError: "कुल संख्या {{min}} से कम नहीं होना चाहिए",
    maxValueError: "कुल संख्या {{max}} से अधिक नहीं होना चाहिए",
    totalAreaError: "कुल रकवा {{max}} से अधिक नहीं होना चाहिए",
    totalAreaMinError: "कुल रकवा {{min}} से कम नहीं होना चाहिए",
    totalAppliedAreaError: "कुल आवेदित रकवा {{max}} से अधिक नहीं होना चाहिए",
    totalAreaShuskError:
      "जमीन के विवरण से ज्यादा रकवा में आवेदन दर्ज नहीं कर सकते हैं",
    checkboxRequired: "कृपया चेकबॉक्स चुनें",
    radioRequired: "एक का चयन करें",
    fileRequired: "कोई फ़ाइल चयनित नहीं है",
    appliedAcreageError:
      "आवेदित रकवा ({{floatVal}}) को कुल रकवा ({{totalArea}}) से ज्यादा नहीं किया जा सकता",
    districtNotEligible: "किसान के जिले में यह योजना अभी लागू नहीं है",
    pmksyError:
      "PMKSY योजना समूहों के लिए सहायक मोड में उपलब्ध नहीं है। कृपया जारी रखने के लिए 'व्यक्तिगत' चुनें।",
    addNewRowError: "कृपया पिछली प्रविष्टि भरें/जमा करें।",
    addNewRowPreviewError: "कृपया प्रविष्टि जमा करें।",
    pleaseEnterValueMin: "कृपया {{min}} या उससे अधिक प्रविष्टियां करें",
    duplicateReturnPolicy: "कृपया एक अलग मान दर्ज करें",
  },
  COMMON_EDIT: "संपादित करें",
  A: "ए",
  SESSION_EXPIRE_ERROR:
    "आपका सत्र समाप्त हो गया है। कृपया जारी रखने के लिए लॉग इन करें।",
  SCHEME_BENEFITS: "योजना के लाभ",
  SCHEME_HAS_ERRORS:
    "कृपया योजना का पूर्वावलोकन करने से पहले आवश्यक फ़ील्ड भरें। सुनिश्चित करें कि सभी फ़ील्ड सही तरीके से भरे गए हैं।",
  SCHEME_APPLICATION_CREATE_ERROR:
    "यह आवेदन इस समय प्रस्तुत नहीं किया जा सकता। कृपया बाद में फिर से जांचें।",
  SCHEME_APPLICATION_NOT_FOUND: "योजना आवेदन प्राप्त नहीं हुआ",
  REQUEST_IN_PROCESS: "अनुरोध प्रगति पर है",
  SUBMITTED_SUCCESSFULLY: "आवेदन सफलतापूर्वक जमा हो चुका है",
  FAILED: "आवेदन असफल हो चुका है",
  REJECTED_TRACK: "आवेदन अस्वीकृत हो चुका है",
  SCHEME_DOWNLOAD_RECIEPT: "रसीद देखें और डाउनलोड करें",
  AllContacts: "सभी संपर्क देखें",
  Login: "लॉग इन",
  CantLogin: "लॉग इन नहीं कर सकते? पासवर्ड रीसेट का अनुरोध करें",
  AGENT_FARMER_REGISTRATIONS: "किसान पंजीकरण",
  AGENT_GRM_REQUESTS: "जीआरएम अनुरोध उठाए गए",
  AGENT_SCHEMES_APPLIED: "लागू योजनाएँ",
  BENIFICIARY_ID: "लाभार्थी आईडी",
  BENIFICIARY_NAME: "लाभार्थी किसान का नाम",
  copyright: "कॉपीराइट",
  DATE_TIME: "तिथि और समय",
  DFSWEB_AGENT: "एजेंट",
  DFSWEB_ASSETS: "कृषि संसाधन",
  Policy: "नीति",
  DFSWEB_ASSETS_details: "कृषि संसाधन विवरण",
  DFSWEB_CAROUSEL: "बिहार कृषि वेब कैरोसेल",
  COMMON_CLOSE: "बंद करें",
  COMMON_DONE: "हो गया",
  COMMON_NEXT: "आगे बढ़ें",
  COMMON_PREVIOUS: "पिछला",
  DFSWEB_DFS_REGISTRATION: "बिहार कृषि पंजीकरण",
  COMMON_NO_FILE_SELECTED: "कोई फ़ाइल चयनित नहीं",
  COMMON_PROCEED_WITH_OTP: "ओटीपी के साथ आगे बढ़ें",
  COMMON_DOWNLOAD_RECIEPT: "रसीद देखें और डाउनलोड करें",
  COMMON_CONGRATS: "बधाई हो !",
  COMMON_LOADING: "लोड हो रहा है, कृपया प्रतीक्षा करें...",
  COMMON_VIEW_ALL: "सभी को देखें",
  DFSWEB_GRM: "जीआरएम",
  DFSWEB_HELP: "सहायता",
  Help: "सहायता",
  "Help-details": "सहायता विवरण",
  DFSWEB_HOME: "होम",
  DFSWEB_HISTORY: "हिस्ट्री",
  Privacy_policy: "गोपनीयता नीति",
  DFSWEB_MANDIPRICE: "बाजार भाव",
  DFSWEB_SCHEMES: "योजनाएँ",
  DFSWEB_FAQs: "अक्सर पूछे जाने वाले प्रश्न",
  DFSWEB_About: "हमारे बारे में",
  DFSWEB_About_Bihar: "बिहार कृषि (एक परिचय)",
  DFSWEB_Latest_Updates: "नवीनतम अपडेट",
  DFSWEB_Success_Volumes: "सफलता  विवरणी",
  DFSWEB_SERVICEPROVIDER: "सेवा प्रदाता",
  DFSWEB_TRACK: "ट्रैक",
  ENTER_VALUE: "मान दर्ज करें",
  PROFILE_CREATE: "गैर-डी. बी. टी. पंजीकरण",
  PROFILE_UPDATE: "डी. बी. टी. प्रोफ़ाइल सिंक",
  PERSONAL_DETAILS: "व्यक्तिगत जानकारी",
  Location_DETAILS: "स्थान जानकारी",
  Bank_DETAILS: "बैंक जानकारी",
  DBT_PROFILE_CREATE: "डीबीटी पंजीकरण",
  SCHEME_APPLY: "योजना आवेदन",
  GRM_APPLY: "शिकायत पंजीकरण",
  DFSWEB_GRM9: "समस्या को रिपोर्ट और ट्रैक करें",
  "Edit-profile": "प्रोफ़ाइल संपादित करें",
  FETCH_PGR_ERROR: "शिकायत विवरण नहीं मिला, कृपया पुनः प्रयास करें",
  FILE_UPLOADING: "अपलोड हो रहा",
  FILE_UPLOAD_FAILED: "विफल",
  FILE_UPLOADED: "अपलोड",
  Grm: "शिकायत प्रबंधन",
  HISTORY_TICKET_NUMBER: "आवेदन/टिकट संख्या",
  INVALID_TICKET_ID: "शिकायत विवरण नहीं मिला, कृपया पुनः प्रयास करें",
  OTP_VALIDATION_FAILED: "अमान्य ओ.टी.पी",
  TECH_COMMON_SUBMIT: "जमा करें",
  KnowMore: "और जानें",
  passbookSessionTimeout:
    "किसान सत्र समाप्त हो गया है। कृपया इस किसान के पासबुक तक पहुँचने के लिए पुनः प्रमाणित करें।",
  dialogContent:
    "आपको एक बाहरी वेबसाइट पर पुनर्निर्देशित किया जा रहा है। कृपया ध्यान दें कि बिहार कृषि वेबसाइट बाहरी वेबसाइटों की सामग्री और गोपनीयता नीतियों के लिए उत्तरदायी नहीं हो सकती।",
  Frequently_Asked_Questions: "सामान्य प्रश्न",
  govtOfBihar: "बिहार सरकार",
  lastUpdate: "अंतिम अद्यतन तिथि",
  BiharKrishiSupport: "बिहार कृषि सहायता",
  KisanCallCentre: "किसान कॉल सेंटर (टोल फ्री)",
  DBTPortal: "डीबीटी पोर्टल",
  BiharSeedCertificationAgency: "बिहार राज्य बीज प्रमाणीकरण एजेंसी",
  BAVAS: "बिहार कृषि उत्पाद मूल्यवर्धन प्रणाली (बवास)",
  DirectorateofHorticulture: "उद्यान निदेशालय",
  KisanCallCentrePortal: "किसान कॉल सेंटर पोर्टल",
  header: "संपर्क जानकारी",
  History: "इतिहास",
  ContactInformation: "संपर्क जानकारी",
  OtherImportantLinks: "अन्य महत्वपूर्ण लिंक",
  ImportantLinks: "महत्वपूर्ण लिंक",
  FollowUs: "हमें फॉलो करें",
  krishiAppPlay:
    "सरकारी योजनाओं का लाभ उठाने के लिए बिहार कृषि ऐप डाउनलोड करें",
  Skip_to_main_content: "मुख्य सामग्री पर जाएं",
  Screenreaderaccess: "स्क्रीन रीडर एक्सेस",
  ScreenReader: "स्क्रीन रीडर",
  Website: "वेबसाइट",
  FreeCommercial: "फ्री / कमर्शियल",
  schemeBanner: "सभी सक्रिय राज्य और केंद्र प्रायोजित योजनाएँ देखें।",
  Click: "क्लिक करें",
  imp_updates: "महत्वपूर्ण अपडेट",
  DepartofAgri: "कृषि विभाग",
  Cancel: "रद्द करें",
  OK: "ठीक है",
  EMPTY_DBT_ID: "कृपया डी.बी.टी दर्ज करें और फिर आगे बढ़ें।",
  INVALID_DBT_ID:
    "दर्ज किया गया डी.बी.टी अमान्य है। कृपया अपनी जानकारी जांचें और फिर से प्रयास करें।",
  FARMER_DOES_NOT_EXIST:
    "आपका मान्य DBT ID बिहार कृषि पर पंजीकृत नहीं है। कृपया लाभ और सेवाओं के लिए पंजीकरण करें।",
  INVALID_OTP: "अमान्य ओ.टी.पी",
  INCORRECT_OTP: "अमान्य ओ.टी.पी",
  IP_ADDRESS_ERROR:
    "आपका IP पता प्राप्त किया जा रहा है, कृपया प्रतीक्षा करें...",
  KeyContacts: "मुख्य संपर्क",
  LatestNews: "ताज़ा खबर",
  LearnMore: "और अधिक जानें",
  LogInToAccount: "अपने खाते में लॉग इन करें",
  NumberAboutOurSuccess:
    'संख्याएँ जो हमारी <span style="color: {{color}};">सफलता</span> के बारे में कहती हैं!',
  Success: "सफलता!",
  OurOfferings: "हमारी सेवाएँ",
  Photos: "फोटो",
  QuickAction: "त्वरित कार्रवाई",
  ReadMore: "और पढ़ें",
  ReadLess: "कम पढ़ें ",
  REPORT_A_ISSUE: "किसी समस्या की रिपोर्ट करें",
  scan_to_download: "बिहार कृषि मोबाइल ऐप डाउनलोड करने के लिए इसे स्कैन करें",
  Social: "सोशल मीडिया",
  TICKET_NUMBER: "टिकट नंबर",
  TRACK_ISSUE_STATUS: "समस्या की स्थिति को ट्रैक करें",
  TYPE_OF_REQUEST: "अनुरोध का प्रकार",
  Videos: "वीडियो",
  View_all_daq: "सभी सामान्य प्रश्न देखें",
  View: "देखें",
  ViewAllOfferings: "सभी पेशकशें देखें",
  ViewAllSchemes: "सभी योजनाएँ देखें",
  GotoRegistration: "पंजीकरण पर जाएं",
  CreateTicket: "टिकट बनाएं",
  ViewDetails: "विवरण देखें",
  Report: "रिपोर्ट करें",
  FILE_TYPE_ERROR: "फ़ाइल प्रकार समर्थित नहीं है",
  FILE_UPLOAD_FAILED_ERROR: "अपलोड असफल रहा। कृपया पुनः प्रयास करें!",
  UPLOAD_FILES: "फ़ाइलें अपलोड करें",
  Track: "ट्रैक करें",
  COMMON_HISTORY: "इतिहास",
  REJECTED: "अस्वीकृत",
  SCHEME_APPLICATION_GET_ERROR: "योजना आवेदन नहीं मिला",
  Mandi: "बाज़ार भाव",
  "Price-details": "मूल्य विवरण",
  MANDI_PRICE: "कीमत",
  MANDI_MARKET_PRICE: "बाज़ार मूल्य",
  COMMON_APPLY: "आवेदन करें",
  COMMODITY_PRICE_HEADER: "कीमत",
  MANDI_COMMODITY_PRICE_TREND: "मूल्य प्रवृत्ति",
  MANDI_PAST_PRICES_LABEL: "पिछली कीमतें",
  PRICE_QUINTOL: "क्विंटल",
  MANDI_PRICE_HEADER: "बाज़ार भाव",
  COMMON_DISTRICT: "ज़िला",
  COMMON_BLOCK: "ब्लॉक",
  COMMON_VILLAGE_PANCHAYAT: "ग्राम पंचायत",
  MANDI_MARKET: "बाज़ार",
  MANDI_COMMODITY_CROP: "फसल/वस्तु",
  COMMON_ID: "आईडी",
  COMMON_NAME: "नाम",
  Manager: "मैनेजर",
  COMMON_DELETE: "डिलीट करें",
  COMMON_DELETE_WARNING:
    "क्या आप सुनिश्चित रूप से इस आइटम को डिलीट करना चाहते हैं?",
  COMMON_DELETE_SELECTED_ITEMS_WARNING:
    "क्या आप वाकई चयनित आइटम को हटाना चाहते हैं?",
  COMMON_YES_DELETE: "हाँ, डिलीट करें",
  DELETE_SUCCESSFUL: "रिकॉर्ड सफलतापूर्वक हटा दिया गया है",
  DELETE_MULTI_SUCCESSFUL: "रिकॉर्ड सफलतापूर्वक हटा दिए गए हैं",
  DFSWEB_DATA_REVIEW: "डेटा समीक्षा",
  DFSWEB_DATA_REVIEW_DESC: "यहां से डेटा प्रबंधित करें",
  "Data-cleanup": "डेटा समीक्षा",
  MANDI_FROM_DATE: "की तिथि से",
  MANDI_TO_DATE: "तारीख तक",
  COMMON_DATE: "तारीख",
  MANDI_COMMODITY: "फसल",
  MANDI_VARIETY: "विविधता",
  MANDI_MIN_PRICE: "न्यूनतम कीमत",
  MANDI_MAX_PRICE: "अधिकतम कीमत",
  MANDI_ERROR_LOADING_MARKET_DATA: "डेटा लोड करने में त्रुटि",
  MANDI_NO_MARKET_DATA: "कोई डेटा मौजूद नहीं",
  NoRecordFound: "कोई सुझाव नहीं मिला",
  searchLocation: "स्थान खोजें",
  MANDI_DATE_FILTER_ERROR: "कृपया चुनें",
  SELECT_Date: "तिथि चुनें",
  VERIFY_FARMER: "किसान विवरण सत्यापित करें",
  APPLICATION_FORM: "आवेदन पत्र",
  PREVIEW_SUBMIT: "पूर्वावलोकन और जमा करें",
  Categories: "श्रेणियाँ",
  SearchAssets: "कृषि संसाधन खोजें",
  QuickFilters: "क्विक फ़िल्टर्स",
  Filters: "फ़िल्टर्स",
  Privacypolicy: "गोपनीयता नीति/उपयोग की शर्तें पृष्ठ",
  SearchQuestion: "प्रश्न खोजें",
  SearchContact: "संपर्क खोजें",
  Search: "खोजें",
  contactPerson: "संपर्क व्यक्ति",
  cropName: "फसल का नाम: ",
  CROP_NAME: "फसल का नाम",
  activities: "व्यावसायिक क्षेत्र",
  sourceText: "स्रोतः ",
  sourceWeather: "बिहार मौसम सेवा केंद्र",
  Assets_home_text:
    "कृषि संसाधन अनुभाग में आपका स्वागत है, यहां आप बिहार के सभी जिलों में मौजूद विभिन्न कृषि संस्थानों और संसाधनों की श्रेणीवार जानकारी आसानी से देख सकते हैं। यहाँ से आप राज्य के सभी जिलों में उपलब्ध कृषि संसाधनों की जानकारी एवं संपर्क विवरण प्राप्त कर सकते हैं, साथ ही इन-ऐप कॉल सुविधा के जरिए आप इस अनुभाग में दिए गए किसी भी संपर्क नंबर पर कॉल करके सम्बंधित व्यक्ति से तुरंत संपर्क भी कर सकते हैं।",
  farmerRegistration: {
    PERSONAL_DETAILS: "व्यक्तिगत जानकारी",
    DBT_ID: "डीबीटी आईडी",
    FARMER_NAME: "किसान का नाम",
    "FATHER/MOTHER/HUSBAND_NAME": "पिता/माता/पति का नाम",
    DATE_OF_BIRTH: "जन्म तिथि",
    AGE: "आयु",
    GENDER: "लिंग",
    MOBILE_NUMBER: "मोबाइल नम्बर",
    FARMER_TYPE: "किसान का प्रकार",
    CASTE_CATEGORY: "जाति का प्रकार",
    FARMER_CATEGORY: "कृषक श्रेणी",
    DISTRICT: "जिला",
    BLOCK: "ब्लॉक",
    VILLAGE_PANCHAYAT: "ग्राम पंचायत",
    VILLAGE: "ग्राम",
    PINCODE: "पिन कोड",
    RESEND_OTP: "ओटीपी पुनः भेजें",
    OTP: "ओटीपी",
    PLEASE_VERIFY: "कृपया सत्यापित करें",
    OTP_SENT_TO_MOBILE_NO_1: "हमने आपके पंजीकृत मोबाइल नंबर",
    OTP_SENT_TO_MOBILE_NO_2: "पर एक ओटीपी भेजा है।",
    RETRY1: "",
    RETRY2: "में पुनः कोशिश करें",
    VERIFY: "सत्यापित करें",
    DBT_SYNC: "डीबीटी सिंक",
    SUBMIT: "जमा करें",
    CHANGE_PHOTO: " फोटो बदलें",
    DIDNOT_RECIEVE: "प्राप्त नहीं हुआ?",
    FARMER_ALREADY_EXIST: "किसान पहले से ही बिहार कृषि में मौजूद है।",
    BANK_NAME: "बैंक का नाम",
    ACCOUNT_NUMBER: "खाता सं०",
    IFSC_CODE: "आई.एफ.एस.सी कोड",
    BANK_BRANCH_ADDRESS: "बैंक शाखा का पता",
    REGISTRATION_UPDATE_SUCCESSFUL:
      "आपका बिहार कृषि पंजीकरण सफलतापूर्वक अद्यतन  किया गया है।",
    REGISTRATION_CREATE_SUCCESSFUL:
      "बधाई हो! आपका बिहार कृषि पंजीकरण सफलतापूर्वक बना दिया गया है।",
    CONGRATULATIONS: "बधाई हो!",
    OWN: "रैयत",
    RENTED: "गैर - रैयत",
    MIXED: "रैयत + गैर - रैयत",
    SMALL: "लघु किसान (1-2 हेक्टेअर)",
    MEDIUM: "सीमांत किसान (1 हेक्टेअर से कम)",
    LARGE: "बृहत किसान (2 हेक्टेयर से अधिक)",
    MALE: "पुरुष",
    FEMALE: "महिला",
    OTHER: "अन्य",
    MINORITY: "अल्पसंख्यक",
    SC: "अनुसूचित जाति",
    ST: "अनुसूचित जनजाति",
    OBC: "अन्य पिछड़ा वर्ग",
    BACKWARD: "पिछड़ा वर्ग",
    GENERAL: "सामान्य",
    REQUIRED_FARMER_NAME: "कृपया किसान का नाम लिखें",
    REQUIRED_RELATIVE_NAME: "कृपया किसान के रिश्तेदार का नाम लिखें",
    REQUIRED_DOB: "कृपया जन्म तिथि लिखें",
    REQUIRED_AGE: "कृपया किसान की आयु लिखें",
    REQUIRED_GENDER: "कृपया किसान का लिंग चुनें",
    REQUIRED_MOBILE_NUMBER: "कृपया मोबाइल नंबर लिखें",
    MAXLENGTH_MOBILE_NUMBER: "मोबाइल नंबर 10 अंकों से अधिक नहीं होना चाहिए",
    MINLENGTH_MOBILE_NUMBER: "मोबाइल नंबर कम से कम 10 अंक का होना चाहिए",
    REQUIRED_FARMER_TYPE: "कृपया किसान का प्रकार चुनें",
    REQUIRED_CASTE_CATEGORY: "कृपया किसान की जाति श्रेणी चुनें",
    REQUIRED_FARMER_CATEGORY: "कृपया किसान की श्रेणी चुनें",
    REQUIRED_DISTRICT: "कृपया जिला चुनें",
    REQUIRED_BLOCK: "कृपया प्रखंड चुनें",
    REQUIRED_PANCHAYAT: "कृपया पंचायत चुनें",
    REQUIRED_VILLAGE: "कृपया किसान की श्रेणी चुनें",
    PINCODE_PATTERN: "कृपया 6 अंकों का वैध पिनकोड दर्ज करें",
    NOT_AVAILABLE: "उपलब्ध नहीं है ",
    MOBILE_MAXLENGTH: "मोबाइल नंबर 10 अंकों से अधिक नहीं होना चाहिए",
    MOBILE_MINLENGTH: "मोबाइल नंबर कम से कम 10 अंक का होना चाहिए",
    FARMER_NAME_MINLENGTH: "किसान का नाम कम से कम 2 वर्ण होना चाहिए",
    FARMER_RELATIVE_NAME_MAXLENGTH:
      "किसान के रिश्तेदार का नाम 100 वर्णों से अधिक नहीं होना चाहिए",
    PINCODE_REQUIRED: "कृपया पिनकोड दर्ज करें",
    UNEXPECTED_ERROR: "एक अप्रत्याशित त्रुटि हुई है।",
    UPDATE_NOT_SUPPORTED:
      "सिंक नहीं हो सका: मोबाइल नंबर बदल गया है। कृपया सहायता से संपर्क करें।",
    PHOTO_UPLOAD_SUCCESS: "फ़ोटो सफलतापूर्वक अपलोड हो गया है।",
    EG_FILESTORE_INVALID_INPUT:
      "अवैध फ़ाइल प्रकार। कृपया अपलोड करें: [JPG, JPEG, PNG]।",
    OTP_SEND_FAILED: "OTP भेजने में विफल। कृपया फिर से प्रयास करें।",
    OTP_RESEND_FAILED: "OTP पुनः भेजने में विफल। कृपया फिर से प्रयास करें।",
    INVALID_DBT_ID:
      "दिया गया डी.बी.टी आई.डी अमान्य है। कृपया अपने इनपुट की जाँच करें और फिर से प्रयास करें।",
    RE_LOGIN:"पुनः लॉगिन करें",
    RE_LOGIN_MESSAGE: "आपका मोबाइल नंबर आपके डीबीटी खाते के नंबर के साथ अपडेट कर दिया गया है, कृपया लॉगआउट करें",
    RE_LOGIN_HEADER: "क्षमा करें, डी. बी. टी. आई. डी. और मोबाइल नंबर मेल नहीं खाते"
  },
  Humidity: "नमीयता",
  WindDirection: "हवा की दिशा",
  WindSpeed: "हवा की गति",
  Rain: "बारिश",
  Max_MinTemp: "अधिकतम / न्यूनतम तापमान",
  Date: "तारीख",
  day_forcast: "अगले 3 दिनों का पूर्वानुमान",
  TodayWeather: "आज का मौसम",
  N: "उ.",
  E: "पू.",
  S: "द.",
  W: "प.",
  NE: "उ.पू.",
  SE: "द.पू.",
  SW: "द.प.",
  NW: "उ.प.",
  Weatherdata: "मौसम",
  Sun: "रविवार",
  Mon: "सोमवार",
  Tue: "मंगलवार",
  Wed: "बुधवार",
  Thur: "गुरुवार",
  Fri: "शुक्रवार",
  Sat: "शनिवार",
  get_direction: "दिशा प्राप्त करें",
  Bihar: "Bihar",
  Q: "प्र",
  A: "उ",
  Acc: "अ",
  COMMON_USERNAME: "उपयोगकर्ता नाम",
  COMMON_ENTER_PASSWORD: "",
  COMMON_PASSWORD: "पासवर्ड",
  notEligible: "माफ करें, यह स्थान उपलब्ध नहीं है। कृपया एक अलग स्थान चुनें।",
  notAvaliable:
    "माफ करें! स्थान विवरण मेल नहीं खाता। कृपया सहायता के लिए संपर्क करें।",
  Complaintdetails: "शिकायत विवरण",
  Sitemap: "साइट मैप",
  landingPage: "लैंडिंग पृष्ठ",
  Footer: "फुटर",
  Storage: "स्टोरेज",
  Office: "कृषि कार्यालय",
  Education: "कृषि संस्थान",
  Bazaar: "बाजार",
  OtherAssets: "अन्य संसधान",
  Cold_Storage: "कोल्ड स्टोरेज",
  PACS: "पैक्स",
  Agri_Godowns: "कृषि गोदाम",
  Panchayat_Office: "पंचायत कार्यालय",
  "e-Kisan_Bhavan": "ई-किसान भवन",
  DAO_Office: "डीएओ कार्यालय",
  KVK: "कृषि विज्ञान केंद्र",
  Agriculture_College: "कृषि महाविद्यालय",
  Pashu_Bazaar: "पशु बाजार",
  Market_Nodes: "बाजार समिति",
  Agri_Input_Shops: "कृषि-इनपुट उपादान",
  Agriculture_Farms: "कृषि फार्म",
  Rice_Mill: "राइस मिल",
  Custom_Hiring_Center: "कस्टम हायरिंग सेंटर",
  Traders: "व्यापारी",
  "Fpo-Farmers_Producers_Services": "किसान उत्पादक संगठन",
  Commodity_Price: "फसल कीमत",
  Contact_US: "हमसे संपर्क करें",
  TrackScheme: "योजना ट्रैक",
  FARMER_PASSBOOK: "किसान पासबुक",
  "Farmer-passbook": "किसान पासबुक",
  "Agent-access": "सत्यापन",
  PROCESSING_PASSBOOK_INFO:
    "आपका पासबुक लाया जा रहा है। इसमें कुछ समय लग सकता है, कृपया थोड़ी देर बाद पुनः जांचें।",
  Choose_Year: "वर्ष चुनें",
  SL_NO: "क्रमांक",
  Sub_Scheme_Name: "उप योजना का नाम",
  Application_Date: "आवेदन तिथि",
  Subsidy_Type: "सब्सिडी का प्रकार",
  Settlement_Date: "निपटान तिथि",
  Benefit_Allocation: "लाभ आवंटन",
  Download_PDF: "पीडीएफ डाउनलोड करें",
  help: {
    SpeaktoDOAOfficials:
      "कृषि विभाग के अधिकारियों से बात करें या कॉल सेंटर से जुड़ें",
    CallCenters: "कॉल सेंटर्स",
    DBTIDRelatedServices: "डीबीटी सम्बंधित सेवाएं",
    OtherRelevantServices: "अन्य महत्वपूर्ण सेवाएं",
    MandiAnalysts: "मंडी एनालिस्ट",
    CertificationInspectors: "प्रमाणन निरीक्षक (बीज/जैविक)",
    SAO: "स्थानीय एसएओ अधिकारियों से सम्पर्क करे",
    AgricultureCoordinator: "कृषि समन्वयक",
    KisanSalahkar: "किसान सलाहकार",
    NominatedACforMarketNodes: "मार्केट नोड्स के नामित कृषि समन्वयक",
    AssistantDirectorofPlantProtection: "पौधा संरक्षण-सहायक निदेशक",
    EthanolIndustries: "इथेनॉल उद्योग",
    JaivikFPOs: "जैविक एफपीओ",
    ReportTechnicalissue: "तकनीकी समस्या की रिपोर्ट करें",
    Foodprocessing: "खाद्य प्रसंस्करण",
    availableTimings: "उपलब्ध समय",
    availableDays: "उपलब्ध दिन",
    Capacity: "क्षमता",
    Status: "स्थिति",
    status: "स्थिति",
    address: "पता",
    capacity: "क्षमता",
    establishYear: "स्थापना वर्ष",
    productName: "प्रोडक्ट का नाम",
    majorCrops: "प्रमुख फसलें",
    bac: "मार्केट नोड्स के नामित कृषि समन्वयक",
    commoditiesTraded: "कमोडिटीज ट्रेडेड",
    oci: "जैविक प्रमाणन निरीक्षक",
    si: "बीज प्रमाणन निरीक्षक",
    si1: "बीज प्रमाणन निरीक्षक- 1",
    si2: "बीज प्रमाणन निरीक्षक- 2",
    si3: "बीज प्रमाणन निरीक्षक- 3",
    dao: "DAO",
    dho: "DHO",
    ade: "ADE",
    adc: "ADC",
    noDataFound:
      "कोई डेटा नहीं मिला। कृपया बाद में फिर से जांचें या अपनी खोज को परिष्कृत करें।",
  },
  //soil health
  Soil_health: "मृदा का स्वास्थ्य",
  soil_health_Detail: "मृदा के स्वास्थ्य का विवरण",
  "Soil-health-details": "मृदा के स्वास्थ्य का विवरण",
  soil_health_labs: "मृदा परीक्षण प्रयोगशालाएँ",
  soil_health_card: "मृदा स्वास्थ्य कार्ड",
  agriAdvisory: "कृषि सलाह",
  filterByDistrict: "जिले के अनुसार फ़िल्टर करें",
  Distance: "दूरी",
  Download: "डाउनलोड",
  approx: "लगभग",
  FinancialYears: "वित्तीय वर्ष",
  TestGrid: "परीक्षण ग्रिड",
  KhataKasara: "खाता/खसरा",
  NoOptions: "कोई विकल्प नहीं",
  selectAtLeast1NPK:
    "कृपया नाइट्रोजन, फास्फेट या पोटाश में से कम से कम एक चयन करें।",
  selectAtLeast1Crop: "कृपया कम से कम एक फसल और उसके संबंधित उपज का चयन करें।",
  GenerateReport: "रिपोर्ट उत्पन्न करें",
  Potash: "पोटाश",
  Phosphate: "फास्फेट",
  Nitrogen: "नाइट्रोजन",
  Yield: "उपज",
  Crop: "फसल",
  selectCrop: "कृपया फसलें और लक्ष्य उपज चुनें।",
  LandSize: "भूमि का आकार",
  Check_more_crop: "अधिक फसल देखें",
  selectNPK: "कृपया उर्वरक का चयन करें, जिसे आप उपयोग करना चाहते हैं।",
  NPKGroup: "N.P.K समूह",
  name: "नाम",
  SoilHealthId: "मृदा स्वास्थ्य कार्ड आईडी:",
  Validity: "वैधता:",
  DataAnalysis: "डेटा विश्लेषण",
  Resource: "संसाधन",
  testDate: "परीक्षण तिथि:",
  BasedInput: "डेटा विश्लेषण: डेटा इनपुट्स के आधार पर प्रदर्शित किया गया।:",
  Share: "साझा करें",
  whereShare: "कृपया चयन करें कि आप मृदा का विवरण कहाँ साझा करना चाहते हैं।",
  "Farmer-details": "किसान विवरण सत्यापित करें",
  selectAnotherYear: "कृपया रिकॉर्ड देखने के लिए कोई अन्य वित्तीय वर्ष चुनें।",
  passbookSessionTimeout: "किसान सत्र समाप्त हो गया है।",
  selectArea: "कृपया क्षेत्र और इकाई चुनें।",
  whatsAppSuccess:
    "व्हाट्सएप संदेश सफलतापूर्वक भेजा गया है। कृपया 2-3 मिनट बाद जांचें।",
  whatsAppFailure:
    "व्हाट्सएप संदेश भेजने में कोई समस्या आई है। कृपया कुछ समय बाद पुनः प्रयास करें।",
  farmersDashboard: "किसान पंजीकरण",
  schemesApplications: "योजनाओं के लिए आवेदन",
  grmDashboard: "जीआरएम",
  COMMON_AMOUNT: "राशि",
  Radio: "रेडियो",
  Bihar_Krishi_Radio: "बिहार कृषी रेडियो में ट्यून करें",
  Now_playing_Radio: "अब बिहार कृषि रेडियो चल रहा है",
  Play: "प्ले",
  Pause: "पॉज़",
  Stop: "रोकें",
  Mute: "म्यूट",
  Unmute: "अनम्यूट",
  Volume: "वॉल्यूम",
  Reviews: "समीक्षाएँ",
  Percentage: "प्रतिशत",
  Star: "स्टार",
  Stars: "स्टार्स",
  Component: "अवयव",
  Group_description: "समूह का विवरण",
  "Group/Company_Registration_No": "पंजीयन संख्या",
  "Group/Company_Registration_Date": "पंजीयन तिथि",
  "Group/Company_Name": " ग्रुप/कंपनी का नाम",
  "Applied_Unit_(125_Sq.m._Per_Unit)": "आवेदित इकाई (125 वर्गमीटर प्रति इकाई)",
  "Acreage_(in_Acres)": "कूल रकवा(एकड़ में)",
  selectAValue: "एक विकल्प चुनें",
  Farmer: "किसान",
  Others: "अन्य",
  COMMON_MOBILE: "मोबाइल नंबर दर्ज करें",
  COMMON_LOGIN_TYPE: "लॉगिन प्रकार",
  dbt_dfs_registered_phone: "डीबीटी या डीएफएस - पंजीकृत मोबाइल नंबर",
  otp_sent_message_1: "हमने आपके पंजीकृत मोबाइल नंबर {{maskedMobile}}",
  otp_sent_message_2: " पर एक वन-टाइम पासवर्ड भेजा है।",
  COMMON_MOBILE_INVALID: "यह नंबर पंजीकृत नहीं है",
  All_Schemes: "सभी योजनाएँ",
  Applied_Schemes: "आवेदन की गई योजनाएँ",
  remarks:"टिप्पणी",
  Refresh:"रिफ्रेश",
  requiredRegistrationGRM:
    'कृषि विभाग की योजनाओं में आवेदन करने के लिए डीबीटी पोर्टल पर पंजीकरण की आवश्यकता है। आगे बढ़ने के लिए डीबीटी पोर्टल पर पंजीकरण करें।',
  Date_of_Application: "आवेदन की तिथि",
  APPLICATION_STATUS: "आवेदन की स्थिति",
  Applied: "आवेदन किया",
  address: "पता",
  COMMON_MOBILE_REQUIRED: "कृपया मोबाइल नंबर दर्ज करें",
  MOBILE_NUM_CHANGE_1: `कृपया ध्यान दें, आपके द्वारा दर्ज की गई डीबीटी आईडी किसी अन्य मोबाइल नंबर {{maskedMobileNumber}} से जुड़ी हुई है। यदि यह आपका मोबाइल नंबर है तो कृपया आगे बढ़ने के लिए पूरा मोबाइल नंबर दर्ज करें। कृपया ध्यान दें कि इस मोबाइल नंबर से जुड़े प्रोफ़ाइल विवरण को इस प्रोफ़ाइल पर मैप किया जाएगा।`,
  MOBILE_NUM_CHANGE_2: `यदि आप निश्चित हैं, तो कृपया "आगे बढ़ें" बटन पर क्लिक करें अन्यथा वापस जाने के लिए "रद्द करें" बटन पर क्लिक करें।`,
  FETCHED_DATA: "डेटा सफलतापूर्वक प्राप्त किया गया",
  MOBILE_MISMATCH: "मोबाइल नंबर मेल नहीं खाते हैं",
  MOBILE_ALREADY_REGISTERED: "मोबाइल नंबर पहले से ही पंजीकृत है। कृपया इस मोबाइल नंबर से लॉग इन करें।",
  selfRegistration: {
    haveDBT: "क्या आपके पास डी. बी. टी. आई.डी. है?",
    registerDBT: "क्या आप डी. बी. टी. में पंजीकरण कराना चाहते हैं?",
    dbtLinkHelper: "डी. बी. टी. पोर्टल में रजिस्ट्रेशन हेतु नीचे दिये गये लिंक पर क्लिक करें",
    dbtDetails: "डी. बी. टी. विवरण",
    fetchData: "डी. बी. टी. डेटा प्राप्त करें",
    fetchPermission: "क्या आप डी. बी. टी. पोर्टल से विवरण प्राप्त करना चाहेंगे?",
    dbtInputLabel: "किसान डी. बी. टी. रजिस्ट्रेशन नंबर (13 अंक)",
    continue: "आगे बढ़ें",
    mobileInputLabel: "मोबाइल नंबर",
    mobileInputHelper: "साइन अप के लिए डी. बी. टी. पंजीकृत मोबाइल नंबर {{maskedMobile}} का उपयोग करें।",
    back: "बाहर निकलें",
    notEligible: "माफ करें! स्थान विवरण मेल नहीं खाता। कृपया सहायता के लिए संपर्क करें।",
    DBT_ERROR:"सर्वर से डीबीटी विवरण प्राप्त करते समय त्रुटि, कृपया कुछ समय बाद पुनः प्रयास करें!",
  },
  Farmer_Registration: "किसान-पंजीकरण",
  kg: "किग्रा",
};
